import gsap from "gsap";

const animateNavigation = () => {
    const highlightsButton = document.querySelector(".navbar-submenu-mobile-card.card-highlights");
    highlightsButton.addEventListener("click", () => {
        var tl = gsap.timeline();
        tl.to(
            "#navbar-submenu-mobile-main",
            {
                x: "-100%",
                duration: 0.2
            },
            "<"
        );
        tl.to(
            "#navbar-submenu-mobile-highlights",
            {
                x: "0",
                duration: 0.2
            },
            "<"
        )
    })
        
    const highlightsBackButton = document.querySelector("#navbar-submenu-mobile-highlights-back");
    highlightsBackButton.addEventListener("click", () => {
        var tl = gsap.timeline();
        tl.to(
            "#navbar-submenu-mobile-highlights",
            {
                x: "100%",
                duration: 0.2
            },
            "<"
        )
        tl.to(
            "#navbar-submenu-mobile-main",
            {
                x: "0",
                duration: 0.2
            },
            "<"
        );
    })

    const eventsButton = document.querySelector(".navbar-submenu-mobile-card.card-events");
    eventsButton.addEventListener("click", () => {
        var tl = gsap.timeline();
        tl.to(
            "#navbar-submenu-mobile-main",
            {
                x: "-100%",
                duration: 0.2
            },
            "<"
        );
        tl.to(
            "#navbar-submenu-mobile-events",
            {
                x: "0",
                duration: 0.2
            },
            "<"
        )
    })

    const eventsBackButton = document.querySelector("#navbar-submenu-mobile-events-back");
    eventsBackButton.addEventListener("click", () => {
        var tl = gsap.timeline();
        tl.to(
            "#navbar-submenu-mobile-events",
            {
                x: "100%",
                duration: 0.2
            },
            "<"
        )
        tl.to(
            "#navbar-submenu-mobile-main",
            {
                x: "0",
                duration: 0.2
            },
            "<"
        );
    })
}

export default animateNavigation;